import { render, staticRenderFns } from "./ContentAi.vue?vue&type=template&id=942db61a&scoped=true"
import script from "./ContentAi.vue?vue&type=script&lang=js"
export * from "./ContentAi.vue?vue&type=script&lang=js"
import style0 from "./ContentAi.vue?vue&type=style&index=0&id=942db61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942db61a",
  null
  
)

export default component.exports